import { EntryStateService } from "../sdServices/authentication/entry-state-service";
import { MsalAuthenticationServiceImplementation } from "../sdServices/msal/msal-authentication-service";

export class LogoutController {
  public showCommConsole = false;
  private entryStatePromise: ng.IPromise<string>;

  // @ngInject
  constructor(
    private $window: ng.IWindowService,
    private msalAuthenticationService: MsalAuthenticationServiceImplementation,
    private entryStateService: EntryStateService,
    private $rootScope: ng.IScope
  ) {
    this.entryStatePromise = entryStateService.getEntryState();
    this.entryStatePromise.then((x) => {
      if (x == "comm") {
        $rootScope.$evalAsync(() => {
          this.showCommConsole = true;
        });
      }
    });
  }

  public goHome() {
    this.msalAuthenticationService.logout();
    this.entryStatePromise.then((entryState) => {
      // Note; location must be changed so that on login completion the user is sent back to the entry state, not this logout page
      this.$window.location.hash = entryState;
      this.$window.location.replace(this.$window.location.href);
    });
  }
}
